module.exports = __webpack_public_path__ + "media/images/icons/cross-4c761f4720b304e71640a53867f2c4e8.svg";